import {WorkflowEventBindingsContainer} from './components/workflow-event-bindings-container';

export default {
    component: WorkflowEventBindingsContainer
};
